/** BBRef franchise URL code → NBA.com CDN team id (current 30). */
export const NBA_CDN_TEAM_IDS = {
  ATL: 1610612737,
  BOS: 1610612738,
  NJN: 1610612751,
  CHA: 1610612766,
  CHI: 1610612741,
  CLE: 1610612739,
  DAL: 1610612742,
  DEN: 1610612743,
  DET: 1610612765,
  GSW: 1610612744,
  HOU: 1610612745,
  IND: 1610612754,
  LAC: 1610612746,
  LAL: 1610612747,
  MEM: 1610612763,
  MIA: 1610612748,
  MIL: 1610612749,
  MIN: 1610612750,
  NOH: 1610612740,
  NYK: 1610612752,
  OKC: 1610612760,
  ORL: 1610612753,
  PHI: 1610612755,
  PHO: 1610612756,
  POR: 1610612757,
  SAC: 1610612758,
  SAS: 1610612759,
  TOR: 1610612761,
  UTA: 1610612762,
  WAS: 1610612764,
};

/**
 * Season `team_id` values in player HTML (including historical codes)
 * so a franchise page can find SuperSonics on OKC, etc.
 */
export const NBA_FRANCHISE_SEASON_IDS = {
  ATL: ["ATL", "STL", "MLH", "TRI"],
  BOS: ["BOS"],
  NJN: ["BRK", "NJN", "NYA", "NYN", "NJA"],
  CHA: ["CHA", "CHO", "CHH"],
  CHI: ["CHI"],
  CLE: ["CLE"],
  DAL: ["DAL"],
  DEN: ["DEN", "DNA", "DNR"],
  DET: ["DET", "FTW"],
  GSW: ["GSW", "SFW", "PHW"],
  HOU: ["HOU", "SDR"],
  IND: ["IND", "INA"],
  LAC: ["LAC", "SDC", "BUF"],
  LAL: ["LAL", "MNL"],
  MEM: ["MEM", "VAN"],
  MIA: ["MIA"],
  MIL: ["MIL"],
  MIN: ["MIN"],
  NOH: ["NOP", "NOH", "NOK"],
  NYK: ["NYK"],
  OKC: ["OKC", "SEA"],
  ORL: ["ORL"],
  PHI: ["PHI", "SYR"],
  PHO: ["PHO"],
  POR: ["POR"],
  SAC: ["SAC", "KCK", "KCO", "CIN", "ROC"],
  SAS: ["SAS", "SAA", "TEX", "DLC"],
  TOR: ["TOR"],
  UTA: ["UTA", "NOJ"],
  WAS: ["WAS", "WSB", "CAP", "BAL", "CHZ", "CHP"],
};

export function nbaSeasonIdsForFranchise(franchiseId) {
  const id = String(franchiseId || "").toUpperCase();
  return NBA_FRANCHISE_SEASON_IDS[id] || (id ? [id] : []);
}

const NBA_SEASON_ID_TO_FRANCHISE = Object.fromEntries(
  Object.entries(NBA_FRANCHISE_SEASON_IDS).flatMap(([franchiseId, aliases]) =>
    aliases.map((alias) => [alias, franchiseId])
  )
);

export function getNbaCdnTeamId(franchiseId) {
  const id = String(franchiseId || "").toUpperCase();
  const canonical = NBA_CDN_TEAM_IDS[id] ? id : NBA_SEASON_ID_TO_FRANCHISE[id];
  return NBA_CDN_TEAM_IDS[canonical] || null;
}

export function getNbaTeamLogoUrl(franchiseId) {
  const cdnId = getNbaCdnTeamId(franchiseId);
  if (!cdnId) return null;
  return `https://cdn.nba.com/logos/nba/${cdnId}/global/L/logo.svg`;
}
